import { BaseApi } from '../base'
import { Fetcher } from '@/api/fetcher'
import { ApiHandlerResult } from '..'
import {
  NEXT_API_URL,
  SEND_MAIL_API_SECRET,
  SEND_MAIL_API_SECRET_HEADER,
} from '@/constants'
import { SendTemplatedEmailRequest } from '@/lib/sendgrid/sendgrid-dispatcher'

export class SendMailApi extends BaseApi {
  constructor(fetcher: Fetcher) {
    super(fetcher)
  }

  async send(
    body: SendTemplatedEmailRequest,
    options?: RequestInit
  ): ApiHandlerResult<{ success: boolean }> {
    try {
      const res = await this.fetcher.post(NEXT_API_URL.SEND_MAIL, {
        body: JSON.stringify(body),
        ...options,
        headers: {
          ...options?.headers,
          [SEND_MAIL_API_SECRET_HEADER]: SEND_MAIL_API_SECRET,
        },
      })

      return await this.parseBodyOrThrow(res)
    } catch (err: any) {
      return [err, null]
    }
  }
}
